import React from 'react';
import { list } from '../../../utils/array';
import {CurrencyFormatter, ProductColumn, UnitFormatter} from '../../../utils/formatters';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {UnitConvertComponent} from "src/components/classes/Unit";

class ProductMaterialList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        props.view = list(props.view, "product.id", "material.unit");
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "ProductMaterialList"}
                {...props}
                onLoadCompleted={(response) => {
                    this?.props?.setListCount(parseInt(response?.fullcount || "0"));
                    return response;
                }}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    ...(!this.props.presets?.product ? {"product.displayname": {
                        header: 'Termék',
                        width: 4,
                        sortable,
                        filterable,
                        ...ProductColumn("product.id"),
                    }} : {}),
                    "material.name": {
                        header: 'Nyersanyag',
                        width: 4,
                        sortable,
                        filterable
                    },
                    "qty": {
                        header: 'Mennyiség',
                        width: 1,
                        sortable,
                        filterable,
                        className: "unit",
                        renderer: (value, row) => <UnitConvertComponent value={value} unit={row?.material?.unit} />,
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default ProductMaterialList;
